import { isWindowsGpuHost } from '../utils/canvas3dRenderer';

/**
 * Final polish layer for FAB 3D — applied AFTER correct PBR materials and lighting.
 * Tuned for sharp output: light SSAO, tight LED-only bloom, MSAA in composer.
 */
/** Disabled — bloom caused large white floor flares on wide fab layouts. */
export const FAB_BLOOM = {
  intensity: 0,
  luminanceThreshold: 1.15,
  luminanceSmoothing: 0.008,
  mipmapBlur: true,
  radius: 0.38,
} as const;

/** Very subtle contact AO — heavy SSAO reads as whole-scene blur. */
export const FAB_SSAO = {
  intensity: 1.0,
  intensityWindows: 0.65,
  radius: 0.006,
  luminanceInfluence: 0.12,
  bias: 0.035,
} as const;

/** ACES filmic output — brighter floor read, no FAB-wide glow. */
export const FAB_TONE_MAPPING = {
  middleGrey: 0.62,
  whitePoint: 4.0,
  minLuminance: 0.01,
} as const;

/** MSAA in the composer — sharper than SMAA-only on Windows. */
export function getFabPostProcessingMultisampling(windows = isWindowsGpuHost()): number {
  return windows ? 0 : 2;
}

export function getFabSsaoIntensity(windows = isWindowsGpuHost()): number {
  return windows ? FAB_SSAO.intensityWindows : FAB_SSAO.intensity;
}

export function shouldUseSmaaFallback(multisampling: number): boolean {
  return multisampling <= 0;
}
